export const TITLE_PORTAL_TAG_TOOLTIP = 'Uploaded by the title company through the closing portal';
